/* Festi Market — essai isole du pop-up natif Samita. Theme AMELIORATION uniquement.
   Aucun ajout de produit, aucun appel reseau, aucun reglange Samita persistant. */
(function () {
  'use strict';

  // La page de saisie/envoi du devis reste totalement hors perimetre.
  if (/\/pages\/request-for-quote\/?$/i.test(window.location.pathname)) return;

  var SELECTOR = '.rfq-btn, .rfq-collection-btn, [id^="rfq-btn-"], [id^="rfq-collection-btn-"]';
  var KEYS = ['settings', 'config', 'configs', 'quote', 'quoteSettings'];
  var MAX_TRIES = 80;
  var tries = 0;
  var poll = null;

  function applyNativeConfirmation() {
    var root = window.GRFQConfigs;
    if (!root || typeof root !== 'object') return false;

    var found = false;
    var visited = [];
    function visit(obj, depth) {
      if (!obj || typeof obj !== 'object' || depth > 3 || visited.indexOf(obj) !== -1) return;
      visited.push(obj);

      // Deux noms historiques repertories dans les anciens tests FESTI.
      // Ne jamais ajouter de cle inconnue aux configurations Samita.
      if (Object.prototype.hasOwnProperty.call(obj, 'message_type') &&
          typeof obj.message_type === 'string') {
        obj.message_type = 'popupcontinue';
        found = true;
      }
      if (Object.prototype.hasOwnProperty.call(obj, 'message_type_afteratq') &&
          typeof obj.message_type_afteratq === 'string') {
        obj.message_type_afteratq = 'popup';
        found = true;
      }

      var translations = [obj, obj.translation_default];
      translations.forEach(function (source) {
        if (!source || typeof source !== 'object') return;
        if (typeof source.popupcontinue === 'string') source.popupcontinue = 'Continuer les achats';
        if (typeof source.popupviewquote === 'string') source.popupviewquote = 'Voir mon devis';
      });

      KEYS.forEach(function (key) { visit(obj[key], depth + 1); });
    }
    visit(root, 0);
    return found;
  }

  function stop() {
    if (poll !== null) { clearInterval(poll); poll = null; }
  }

  function attempt() {
    tries += 1;
    var found = applyNativeConfirmation();
    if (found || tries >= MAX_TRIES) stop();
    return found;
  }

  // Essayer apres initialisation de l'application, sans boucle permanente.
  if (!attempt()) poll = setInterval(attempt, 100);

  // Restaure le mode natif si Samita recharge ses reglages pendant la session.
  document.addEventListener('click', function (event) {
    var element = event.target;
    if (!element || typeof element.closest !== 'function' || !element.closest(SELECTOR)) return;
    applyNativeConfirmation();
  }, true);
})();